export type ConsentValue = "granted" | "denied";

export type AdConsent = {
    consent_ad_user_data: ConsentValue;
    consent_ad_personalization: ConsentValue;
};

declare global {
    interface Window {
        getCkyConsent?: () => { categories?: Record<string, boolean> } | undefined;
    }
}

const readAdvertisementConsent = (): boolean | undefined => {
    const fromApi = window.getCkyConsent?.()?.categories?.advertisement;
    if (typeof fromApi === "boolean") return fromApi;

    const cookie = document.cookie.match(/(?:^|;\s*)cookieyes-consent=([^;]*)/)?.[1];
    if (!cookie) return undefined;
    const field = decodeURIComponent(cookie).match(/(?:^|,)advertisement:(yes|no)(?:,|$)/)?.[1];
    return field ? field === "yes" : undefined;
};

/**
 * CookieYes "advertisement" category as Consent Mode v2 ad signals. Read at
 * send time (never cached, never awaited) so events fired before the banner is
 * answered go out immediately with the current state. No CookieYes state at
 * all — regions without a banner, script not loaded — counts as granted.
 */
export const getAdConsent = (): AdConsent => {
    let advertisement: boolean | undefined;
    try {
        if (typeof window !== "undefined") advertisement = readAdvertisementConsent();
    } catch {}
    const value: ConsentValue = advertisement === false ? "denied" : "granted";
    return { consent_ad_user_data: value, consent_ad_personalization: value };
};
